module.exports = __webpack_public_path__ + "media/black_screen_sint.2209e26b.mp3";